import request from '@/api/request';
let defaultRequest = request();

export function getVehicles (params) {
  return defaultRequest({
    url: '/vehicle',
    method: 'get',
    params
  });
}

export function deleteVehicles (data) {
  return defaultRequest({
    url: '/vehicle/delete',
    method: 'put',
    data
  });
}

export function switchDevice (data) {
  return defaultRequest({
    url: '/vehicle/switchdevice',
    method: 'put',
    data
  });
}

export function lockDevice (data) {
  return defaultRequest({
    url: '/vehicle/lock',
    method: 'put',
    data
  });
}

export function getVehicleHistory (params) {
  return defaultRequest({
    url: '/vehicle/history',
    method: 'get',
    params
  });
}

export function exportVehicles (params) {
  return defaultRequest({
    url: '/vehicle/export',
    method: 'get',
    params,
    responseType: 'blob'
  });
}



// WEBPACK FOOTER //
// ./src/api/vehicle.js